export const fokontanyModel = {
    label: 'Fokontany',
    tableName: 'fokontany',
    properties: [
        {
            label: 'Commune',
            id: 'commune',
            isForeignKey: true,
            column_name: 'name',
            table_column: 'parent',
            type: 'text',
            example: 'Antanamitarana',
            required: true
        },
        {
            label: 'Nom',
            id: 'name',
            type: 'text',
            example: 'Ambongivato',
            required: true
        }
    ]
}
